export default __webpack_public_path__ + "7f86331db6b7d0bcb09ab1d7d51b4545.png";